import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2120a872"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "projects-page page d-flex flex-column" }
const _hoisted_2 = { class: "page-content flex-grow-1 d-flex flex-column" }
const _hoisted_3 = { class: "page-content-wrapper" }
const _hoisted_4 = { class: "pb-4 d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Projects", -1))
const _hoisted_6 = {
  key: 0,
  class: "page-content-wrapper mb-5"
}
const _hoisted_7 = { class: "row gy-5 mb-5" }
const _hoisted_8 = {
  key: 0,
  class: "text-center"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center"
}

import AppHeader from "@/components/Pages/AppHeader.vue";
import ProjectTile from "@/components/Pages/ProjectTile.vue";
import NewProjectDialog from "@/components/Modals/NewProjectDialog.vue";
import ProjectView from "@/components/Controls/ProjectViewType.vue";
import { ProjectViewType } from "../classes/data-structures/project-view-type";

import { useDataStore } from "@/store/data-store";
import { useUserStore } from "@/store/user-store";
import { ProjectInfo } from "@/swagger";
import { onBeforeUnmount, onMounted, reactive, ref } from "vue";
import Loading from "@/components/Pages/Loading.vue";
import { useAppStateStore } from "@/store/app-state";
import MapView from "../components/Pages/Projects/MapView.vue";
import TimelineView from "../components/Pages/Projects/TimelineView.vue";
import StorageBar from "@/components/Other/StorageBar.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsPage',
  setup(__props) {

const router = useRouter();
const appState = useAppStateStore();
const userStore = useUserStore();
const dataStore = useDataStore();

const newProjectDialog = ref();

const data = reactive({
	projects: [] as ProjectInfo[],
	isLoading: false
});

function createNewProject() {
	newProjectDialog.value.show();
}

function onCreateNewProjectDialogHide(project?:ProjectInfo){
	if (project) {
		router.push({ name: "edit", params: { projectId: project.uuid}, query: {createNewSurvey: "true" } });
	}
}

async function refreshProjects(silently = false) {
	if (!silently) {
		data.isLoading = true;
	}
	console.log("Refreshing projects!");
	if (userStore.state.user) {
		data.projects = await dataStore.getProjects(true) || [];
		if (!silently) {
			data.isLoading = false;
		}
	}
}

let intervalId: number | undefined;

onMounted(async () => {
	refreshProjects();
	intervalId = setInterval(() => {
		refreshProjects(true);
	}, 30000);
})

onBeforeUnmount(() => {
	if (intervalId) {
		clearInterval(intervalId);
		intervalId = undefined;
	}
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, {
      "show-project": false,
      "show-survey": false
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _hoisted_5,
          _createVNode(StorageBar, { class: "mx-auto d-none d-lg-flex" }),
          _createVNode(ProjectView, { class: "ms-auto ms-lg-0" })
        ]),
        _createVNode(StorageBar, { class: "mx-auto d-lg-none my-4" })
      ]),
      (_unref(appState).projectViewType == _unref(ProjectViewType).Grid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.projects, (project) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: project.uuid,
                  class: "project-tile-wrapper col-md-4 col-lg-3"
                }, [
                  _createVNode(ProjectTile, { project: project }, null, 8, ["project"])
                ]))
              }), 128)),
              (data.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(Loading)
                  ]))
                : _createCommentVNode("", true),
              (!data.isLoading && data.projects.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Currently there are no projects. Create a new project to get started "))
                : _createCommentVNode("", true)
            ]),
            _createVNode(NewProjectDialog, {
              ref_key: "newProjectDialog",
              ref: newProjectDialog,
              onOnHide: onCreateNewProjectDialogHide
            }, null, 512),
            _createElementVNode("button", {
              class: "btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (createNewProject()))
            }, "Create new project")
          ]))
        : _createCommentVNode("", true),
      (_unref(appState).projectViewType == _unref(ProjectViewType).Map)
        ? (_openBlock(), _createBlock(MapView, {
            key: 1,
            class: "map"
          }))
        : _createCommentVNode("", true),
      (_unref(appState).projectViewType == _unref(ProjectViewType).Timeline)
        ? (_openBlock(), _createBlock(TimelineView, { key: 2 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})